import { useEffect, useMemo, useState } from "react";
import { Search, FilePlus2 } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const useTitles = (enabled = true) => {
  const [titles, setTitles] = useState([]);
  useEffect(() => { if (enabled) api.get("/articles/titles").then((r) => setTitles(r.data)); }, [enabled]);
  return titles;
};

export const LinkPickerDialog = ({ open, onOpenChange, onPick, onMissing, selectedText }) => {
  const titles = useTitles(open);
  const [q, setQ] = useState("");
  useEffect(() => { if (open) setQ(selectedText || ""); }, [open, selectedText]);
  const list = useMemo(() => titles.filter((t) => t.title.toLowerCase().includes(q.toLowerCase())).slice(0, 60), [titles, q]);
  const exact = titles.some((t) => t.title.toLowerCase() === q.trim().toLowerCase());

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="link-picker-modal" className="bg-[#f4efe2] border-2 border-[#c9a227] rounded-none max-w-lg">
        <DialogTitle className="font-display text-2xl">Link to a page</DialogTitle>
        <DialogDescription className="italic">{selectedText ? <>Linking “<b>{selectedText}</b>”</> : "Inserts a linked page title at the cursor."}</DialogDescription>
        <div className="flex items-center gap-2 border border-[#c9a227] bg-white/70 px-3 py-2">
          <Search className="w-4 h-4" />
          <input autoFocus data-testid="link-picker-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search pages…" className="bg-transparent outline-none w-full" />
        </div>
        <div className="max-h-72 overflow-auto border border-[#c9a227]/40">
          {list.map((t) => (
            <button key={t.id} type="button" data-testid={`link-picker-item-${t.slug}`} onClick={() => onPick(t)} className="w-full text-left px-4 py-2.5 border-b border-[#c9a227]/20 hover:bg-[#c9a227]/15 transition-colors">
              <span className="font-heading text-sm">{t.title}</span>
              {!t.published && <em className="ml-2 text-xs text-[#991b1b]">draft</em>}
              <span className="block text-xs text-[#5e4a35]">/wiki/{t.slug}</span>
            </button>
          ))}
          {list.length === 0 && <p className="p-4 text-sm italic">No matching pages.</p>}
        </div>
        {q.trim() && !exact && (
          <button type="button" data-testid="link-picker-missing" onClick={() => onMissing(q.trim())} className="inline-flex items-center gap-2 text-sm font-heading text-[#1e4976] hover:underline">
            <FilePlus2 className="w-4 h-4" /> Link to unwritten page “{q.trim()}” (auto-links once you create it)
          </button>
        )}
      </DialogContent>
    </Dialog>
  );
};
